import {
  getVariable,
  useTheme
} from "@tamagui/web";
const useCurrentColor = (colorProp) => {
  const theme = useTheme();
  return getVariable(colorProp || theme[colorProp] || theme.color);
};
export {
  useCurrentColor
};
//# sourceMappingURL=useCurrentColor.js.map
